
<template>
    <div  class=" dialog">
        <el-dialog
            :close-on-click-modal="closeModal"
            title="生成报告"
            :visible.sync="show"
            width='400px'
            :before-close="handleClose">
             <el-form class="form-data">
                <el-form-item label="文件名称："  label-width="90px">
                    <el-input v-model="reportName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click.native="onClick('cancel',$event)" v-if='cancel'  class="cancel-btn" >{{cancel}}</el-button> -->
                <el-button @click.native="report_sure" v-if='ok' type="primary" class="medical-btn" :loading='save'>{{ok}}</el-button>
                <!-- <el-button @click.native="onClick('ok',$event)" v-if='ok' type="primary" class="medical-btn" :loading='save'>{{ok}}</el-button> -->
            </span>
        </el-dialog>
    </div>
    
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
import {createExport} from '../../../io/api.js'
export default {
    props:{
        cancel:{
            type: String,
        },
        ok:{
            type: String,
        },
        show:{
            type: Boolean,
        },
        save:{
            type: Boolean,
            default:false
        },
        closeModal:{
            type: Boolean,
            default:true
        },
        titleName:{
            type: String,
        },
        reportList:{
            type:Array,
        },
        reportList2:{
            type:Array,
        },
        reportImg:{
            // type: String,
        },
    },
    data() {
        return {
            reportName: '',
        };
    },
    computed: {
        ...mapState({ 
            // chartName:state=>state.excavate.chartName,
            // echartList:state=>state.excavate.echartList,
            // radarEchart:state=>state.excavate.radarEchart,
            // isTcm:state=>state.excavate.isTcm,
            // chartType:state=>state.excavate.chartType,
            // navType:state=>state.excavate.navType,
        })
    },
    methods: {
        
        onClick (msg,e) {
            if(msg=='cancel'){
                this.handleClose();
            }else{
                this.$emit(msg,e);
            }
            
        },
        // 生成报告
        report_sure(){
            if(this.reportName==''){
                this.$message.error('请输入文件名称');
                return
            }
            
            let params={
                fileName:this.reportName,
                img:this.reportImg,
                title: this.titleName,
                list:JSON.stringify(this.reportList),
                list2:JSON.stringify(this.reportList2),
            }
            createExport(params).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.$message({ 
                        message: '生成报告成功',
                        type: 'success'
                    });
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }

                // this.reportName='';
                this.handleClose();
            })
        },
        handleClose() {
            if(this.save)return
            this.reportName='';
            this.$emit('update:show',false)
            this.$emit('update:save',false)
            // this.$emit('cancel');
        },
    }
  };
</script>
    
<style lang='less' scoped>
.dialog /deep/ .el-dialog__header{
        line-height: 24px;
        background-color:  #409EFF;
        font-size: 18px;
        padding: 10px 20px;
        .el-dialog__title{
            color: #fff;
        }
    }
 .dialog /deep/  .el-dialog__header{
    line-height: 24px;
    background-color:  #409EFF;
    font-size: 18px;
    padding: 10px 20px;
    .el-dialog__title{
        color: #fff;
    }
}
.dialog /deep/ .el-dialog__headerbtn{
    top:12px;
    .el-dialog__close{
        color: #fff !important;
    }
    
}
 
.dialog /deep/ .el-dialog__body{
    padding: 20px !important;
}
.dialog /deep/ .el-dialog__footer{
    padding-top: 0;
    text-align: center;
}
    
</style>